<template>
  <!-- Investor login monitoring -->
  <div class="login-monitor-container">
    <!-- Query form area -->
    <div class="search-form">
      <a-form layout="inline">
        <a-form-item :label="$t('repayReport.datadt')">
          <a-range-picker v-model="dateRange" :format="'DD-MM-YYYY'" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
          <!-- <a-button type="primary" @click="handleExport" style="margin-left: 8px">{{ $t('exportFile') }}</a-button> -->
        </a-form-item>
      </a-form>
    </div>

    <!-- Data table -->
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      :row-key="(record, index) => `${record.statDate}_${index}`"
      :scroll="{ x: 'max-content' }"
      class="monitor-table"
      @change="handleTableChange"
    >
      <!-- Date column formatting -->
      <template slot="statDate" slot-scope="text, record">
        <span v-if="record.statDate === 'Total'" class="summary-row">{{ text }}</span>
        <span v-else>{{ text ? transformTime(text, 1) : '' }}</span>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getregistMonitor, exportRegistMonitor } from '@/webpublicapi/vietnamBackstage'
export default {
  name: 'LoginNew',
  components: {},
  data() {
    return {
      dateRange: [],
      loading: false,
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '15', '20'],
        showTotal: (total) => `${this.$t('display')} ${total}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('custTrans.requestDate'),
          dataIndex: 'statDate',
          key: 'statDate',
          scopedSlots: { customRender: 'statDate' },
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginSubMobileDistinctNum'),
          dataIndex: 'loginCodeDedup',
          key: 'loginCodeDedup',
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginSubMobileNum'),
          dataIndex: 'loginTotalAttempts',
          key: 'loginTotalAttempts',
          align: 'center',
        },
        {
          title: this.$t('custTrans.avgSubNum'),
          dataIndex: 'avgLoginAttempts',
          key: 'avgLoginAttempts',
          align: 'center',
        },
        {
          title: this.$t('custTrans.validCodeCount'),
          dataIndex: 'validCodeCount',
          key: 'validCodeCount',
          align: 'center',
        },
        {
          title: this.$t('custTrans.subValidMobileProportion'),
          dataIndex: 'validCodeRate',
          key: 'validCodeRate',
          align: 'center',
        },
        {
          title: this.$t('custTrans.sendOtpNum'),
          dataIndex: 'otpSentTotal',
          key: 'otpSentTotal',
          align: 'center',
        },
        {
          title: this.$t('custTrans.regSendOtpMobileDistinctNum'),
          dataIndex: 'otpSentDedup',
          key: 'otpSentDedup',
          align: 'center',
        },
        {
          title: this.$t('custTrans.avgSendNumEveryMobile'),
          dataIndex: 'avgOtpNumber',
          key: 'avgOtpNumber',
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginOperateSucceedNum'),
          dataIndex: 'loginSuccess',
          key: 'loginSuccess',
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginOperateFailNum'),
          dataIndex: 'loginFailed',
          key: 'loginFailed',
          align: 'center',
        },
        {
          title: this.$t('custTrans.unLoginNum'),
          dataIndex: 'noLogin',
          key: 'noLogin',
          align: 'center',
        },
        {
          title: this.$t('custTrans.lockOtpNum'),
          dataIndex: 'otpLockedNumbers',
          key: 'otpLockedNumbers',
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginLockOperateNum'),
          dataIndex: 'unloginLocked',
          key: 'unloginLocked',
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginSuccessRateByTime'),
          dataIndex: 'attemptSuccessRate',
          key: 'attemptSuccessRate',
          align: 'center',
        },
        {
          title: this.$t('custTrans.loginSuccessRateByMobile'),
          dataIndex: 'numberSuccessRate',
          key: 'numberSuccessRate',
          align: 'center',
        },
      ]
    },
  },
  created() {},
  mounted() {
    // Set default time to recent 7 days
    this.setDefaultDateRange()
    // Auto execute one query
    this.handleSearch()
  },
  methods: {
    // Set default date range to recent 7 days
    setDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(end.getDate() - 6) // Including today, total 7 days

      // Use moment.js to format date (Ant Design Vue DatePicker needs moment object)
      const moment = require('moment')
      this.dateRange = [moment(start), moment(end)]
    },

    // Query
    async handleSearch() {
      if (!this.dateRange || this.dateRange.length !== 2) return

      this.loading = true
      const startDate = this.dateRange[0].format('YYYY-MM-DD')
      const endDate = this.dateRange[1].format('YYYY-MM-DD')

      try {
        const result = await getregistMonitor({
          startDate,
          endDate,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
        })

        console.log('API response data:', result)

        if (result.respCode === 1000) {
          const data = result.respData || result.data || result
          this.tableData = data.records
          this.pagination.total = data.total || 0
          console.log('Table data:', this.tableData)
        } else {
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('Query failed:', error)
        this.tableData = []
      } finally {
        this.loading = false
      }
    },

    // Export
    async handleExport() {
      if (!this.dateRange || this.dateRange.length !== 2) return

      const startDate = this.dateRange[0].format('YYYY-MM-DD')
      const endDate = this.dateRange[1].format('YYYY-MM-DD')

      try {
        const result = await exportRegistMonitor({
          startDate,
          endDate,
          pageNo: 1,
          pageSize: 10,
        })

        const blob = new Blob([result], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${startDate}_${endDate}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)
      }
    },

    // Table pagination change
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.handleSearch()
    },
  },
}
</script>

<style scoped>
.login-monitor-container {
  padding: 20px;
  background: #fff;
}

.search-form {
  margin-bottom: 16px;
}

.monitor-table {
  margin-top: 16px;
}

.summary-row {
  font-weight: bold;
}
</style>
